import React from "react";
import { Link } from "react-router-dom";
import { Page } from "@/components/Layout";
import { ArrowRight, GraduationCap, MapTrifold, Briefcase } from "@phosphor-icons/react";
import Seo from "@/components/Seo";
import JsonLd from "@/components/JsonLd";

const pathways = ["School & Pre-University", "Diploma & Vocational Pathways", "Undergraduate Admissions", "Postgraduate Study", "PhD", "DClinPsy", "DEdPsy", "Jobs & Employment", "Career Change", "Study Abroad", "International Transitions"];

export default function ForwardLanding() {
  return (
    <Page>
      <JsonLd
        id="jsonld-service-forward"
        data={{
          "@context": "https://schema.org",
          "@type": "Service",
          name: "MindDhara Forward",
          description: "Psychology career and study-abroad mentorship from psychologists, researchers and academics worldwide.",
          url: "https://minddhara.com/forward",
          provider: { "@type": "Organization", name: "MindDhara", url: "https://minddhara.com" },
          areaServed: "Worldwide",
        }}
      />
      <Seo title="MindDhara Forward · Psychology Mentorship" description="Psychology career and study-abroad mentorship from people who've been there — mentors, packages and a free first conversation." />
      <section className="flow-gradient md-section md-page-hero" data-testid="forward-hero">
        <div className="md-container">
          <div className="md-label-eyebrow mb-4"><span className="md-brand">MindDhara</span> Forward</div>
          <h1 className="text-5xl md:text-6xl font-serif mb-6 max-w-3xl">Move forward, with mentors who&apos;ve been there</h1>
          <p className="text-lg max-w-2xl" style={{ color: "var(--md-text-soft)" }}>Psychology mentorship and career guidance for students, professionals and people in transition.</p>
          <div className="flex flex-wrap gap-3 mt-8">
            <Link to="/mentors?source=forward-hero" className="btn-primary" data-testid="forward-browse-mentors">Browse Mentors <ArrowRight size={14} weight="bold" /></Link>
            <Link to="/forward/packages?source=forward-hero" className="btn-outline" data-testid="forward-packages">See Packages</Link>
            <Link to="/forward/how-it-works?source=forward-hero" className="btn-outline" data-testid="forward-how">How It Works</Link>
          </div>
        </div>
      </section>

      <section className="md-section">
        <div className="md-container">
          <h2 className="text-4xl font-serif mb-3">Eleven pathways. One mentor at a time</h2>
          <p className="text-lg max-w-2xl mb-8" style={{ color: "var(--md-text-soft)" }}>Wherever you are, choose where you want to go next.</p>
          <div className="flex flex-wrap gap-2">
            {pathways.map((p) => <span key={p} className="md-tag">{p}</span>)}
          </div>
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {[{ icon: GraduationCap, title: "Students", desc: "Admissions, applications, mock interviews and academic strategy." },
              { icon: Briefcase, title: "Professionals", desc: "Career change, application reviews and growth conversations." },
              { icon: MapTrifold, title: "Study Abroad", desc: "Cultural adaptation, integration and semester wellbeing." }].map((c) => (
              <div key={c.title} className="md-card">
                <div className="how-glass-ico" style={{ background: "var(--md-bg-alt)", border: "1px solid var(--md-border)" }}>
                  <c.icon size={26} weight="duotone" style={{ color: "var(--md-primary)" }} />
                </div>
                <h3 className="text-2xl font-serif mt-2">{c.title}</h3>
                <p className="mt-2 text-sm" style={{ color: "var(--md-text-soft)" }}>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Page>
  );
}
